export default __webpack_public_path__ + "static/media/cuverd-logo-footer.15b8dfba.png";